import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "yandex-map-3-search-control" }
const _hoisted_2 = { class: "yandex-map-3-search-control__input" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M17.5 17.5L12.5 12.5M14.1667 8.33333C14.1667 11.555 11.555 14.1667 8.33333 14.1667C5.11167 14.1667 2.5 11.555 2.5 8.33333C2.5 5.11167 5.11167 2.5 8.33333 2.5C11.555 2.5 14.1667 5.11167 14.1667 8.33333Z",
    stroke: "#94A3B8",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_4 = ["value", "placeholder"]
const _hoisted_5 = {
  key: 0,
  class: "yandex-map-3-search-control__options"
}
const _hoisted_6 = {
  key: 0,
  class: "options__state"
}
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("input", {
        type: "text",
        value: _ctx.value.value,
        placeholder: _ctx.placeholder,
        onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args)))
      }, null, 40, _hoisted_4)
    ]),
    (Boolean(_ctx.value.value))
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_ctx.options.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, " По вашему запросу ничего не найдено "))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.value, (option, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "options__option",
              key: `search-option-${i}`,
              onClick: ($event: any) => (_ctx.onOptionClicked(option))
            }, [
              _renderSlot(_ctx.$slots, "option", { option: option })
            ], 8, _hoisted_7))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}